/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { cssFns } from "@superweb/css";
import { createColorsContext, palette } from "@superweb/ui";

const [GuidanceColors, useGuidanceColors] = createColorsContext<{
  background: string;
  backgroundInvert: string;
  text: string;
  textMinor: string;
  textInvert: string;
  controlMinor: string;
  line: string;
  new: string;
  recommended: string;
}>({
  light: {
    background: palette.warmGray550,
    backgroundInvert: palette.absoluteWhite,
    text: palette.absoluteWhite,
    textMinor: cssFns.setOpacity(palette.absoluteWhite, 0.5),
    textInvert: palette.warmGray600,
    controlMinor: cssFns.setOpacity(palette.warmGray100, 0.1),
    line: cssFns.setOpacity(palette.warmGray100, 0.2),
    new: palette.greenDark,
    recommended: palette.shamelessBlueNormal,
  },
  dark: {
    background: palette.warmGray500,
    backgroundInvert: palette.absoluteWhite,
    text: palette.absoluteWhite,
    textMinor: cssFns.setOpacity(palette.absoluteWhite, 0.5),
    textInvert: palette.warmGray600,
    controlMinor: cssFns.setOpacity(palette.warmGray100, 0.1),
    line: cssFns.setOpacity(palette.warmGray100, 0.2),
    new: palette.greenDark,
    recommended: palette.shamelessBlueNormal,
  },
});
export { GuidanceColors, useGuidanceColors };
